export default __webpack_public_path__ + "static/media/m_use_action_back_xw.0ea09cae.png";